import {reaction} from 'mobx';
import {observer} from 'mobx-react';
import React from 'react';
import {Disposers} from '../../../../../lib/helpers';
import {EditContentStore} from '../../../x7/content-parts/EditContentStore';
import {SyncedAudioModel} from '../models';
import {syncedAudioEditStoreRenderer} from './synced-audio-edit-store-renderer';
import {SyncedAudioEditStore} from './SyncedAudioEditStore';

@observer
export class X9SyncedAudioEdit extends React.Component<{ store: EditContentStore }> {
  readonly store: SyncedAudioEditStore;
  readonly disposers = new Disposers();

  constructor(props: Readonly<{ store: EditContentStore }>) {
    super(props);

    this.store = new SyncedAudioEditStore();
    const value = props.store.content.Contents;
    const model = JSON.parse(value) as SyncedAudioModel;
    this.store.sync(model);

    this.setup();
  }

  render() {
    return Array.from(syncedAudioEditStoreRenderer(this.store));
  }

  private setup() {
    this.disposers.add(
      reaction(
        () => this.store.valid,
        (valid) => this.props.store.setValid(valid),
        {fireImmediately: true}),
      reaction(
        () => this.store.x9Contents,
        (contents) => this.props.store.setContents(contents),
        {fireImmediately: true}));
  }

  componentWillUnmount() {
    this.disposers.dispose();
  }
}
